<template lang="pug">
erp-view(id="ControlPermisos" ref="ControlPermisos" title="Control de Permisos")

  template(slot="header-action")
    dx-button(text="Nuevo Permiso" icon="fa fa-plus" type="success" @click="nuevoPermiso")
    dx-button(text="Editar" icon="fa fa-edit" type="default" @click="editarPermiso")
    dx-button(text="Eliminar" icon="fa fa-trash" type="danger" @click="eliminarPermiso")

  template(slot="content")
    dx-data-grid(:data-source="permisos" :show-borders="true" key-expr="codigo")
      dx-column(data-field="codigo" caption="Código" width="150")
      dx-column(data-field="nombre" caption="Permiso" width="250")
      dx-column(data-field="descripcion" caption="Descripción" width="400")
      dx-column(data-field="estado" caption="Estado" width="100")
</template>

<script>
import { DxDataGrid, DxColumn, DxButton } from "devextreme-vue/data-grid";

export default {
  name: "ControlPermisos",
  components: { DxDataGrid, DxColumn, DxButton },
  data() {
    return {
      permisos: [
        { codigo: "USR_ADD", nombre: "Agregar Usuario", descripcion: "Crea nuevos usuarios", estado: "Activo" },
        { codigo: "ROL_EDIT", nombre: "Editar Rol", descripcion: "Modifica permisos de roles", estado: "Activo" },
        { codigo: "PERM_VIEW", nombre: "Ver Permisos", descripcion: "Permite visualizar permisos", estado: "Inactivo" },
      ],
    };
  },
  methods: {
    nuevoPermiso() { this.$msg.info("Abrir popup: Nuevo Permiso"); },
    editarPermiso() { this.$msg.info("Editar permiso seleccionado"); },
    eliminarPermiso() { this.$msg.confirm("¿Deseas eliminar este permiso?"); },
  },
};
</script>
